export const wizardWorkzPalette = {
  common: {
    black: "#101012",
    white: "#FFFFFF",
  },
  primary: {
    main: "#144835",
    dark: "#09733E",
    darker: "#075A31",
    moreDarker: "#054023",
    darkest: "#032715",
    light: "#37A16C",
    lighter: "#63B58C",
    moreLighter: "#8FCAAD",
    lightest: "#BBDFCD",
    lightest2: "#E7F4ED",
  },
  secondary: {
    main: "#2b73de",
    dark: "#2562bd",
    darker: "#1c4b90",
    moreDarker: "#163a6f",
    darkest: "#0f284e",
    light: "#558fe5",
    lighter: "#aac7f2",
    moreLighter: "#d5e3f8",
    lightest: "#e9f1fb",
  },
  error: {
    // naming of error to red
    main: "#e12b1d",
    dark: "#b42217",
    darker: "#9e1e14",
    moreDarker: "#871a11",
    darkest: "#71160f",
    light: "#e7554a",
    lighter: "#f3aaa5",
    moreLighter: "#f9d5d2",
    lightest: "#fce9e8",
  },
  grey2: {
    main: "#505259",
    dark: "#44464c",
    darker: "#34353a",
    moreDarker: "#28292d",
    darkest: "",
    light: "#73757a",
    lighter: "#b9babd",
    moreLighter: "#dcdcde",
    lightest: "#ededee",
    lightest2: "#f6f6f6",
  },
  complementary: {
    main: "#8a68ab",
    dark: "#755891",
    darker: "#5a446f",
    moreDarker: "#453456",
    darkest: "#30243c",
    light: "#a186bc",
    lighter: "#d8cee3",
    moreLighter: "#e8e1ee",
    lightest: "#f5f2f8",
  },
  orange: {
    main: "#f28500",
    dark: "#da7800",
    darker: "#c26a00",
    moreDarker: "#9d5600",
    darkest: "#613500",
    light: "#f59d33",
    lighter: "#face99",
    moreLighter: "#fce7cc",
    lightest: "#fdf2e5",
  },
  yellow: {
    main: "#fcc945",
    dark: "#e3b53e",
    darker: "#b08d30",
    moreDarker: "#7e6523",
    darkest: "#584618",
    light: "#fdd46a",
    lighter: "#fee9b5",
    moreLighter: "#fef4da",
    lightest: "#fef9ec",
  },
  cta: {
    main: "#144835",
    dark: "",
    darker: "",
    moreDarker: "",
    darkest: "",
    light: "",
    lighter: "",
    moreLighter: "",
    lightest: "",
    lightest2: "",
  },
  wizardText: {
    main: "#F5F5DC",
    dark: "#e4d5b7",
    darker: "#30302c",
    moreDarker: "#d9b99b",
    darkest: "",
    light: "#faf0e6",
    lighter: "",
    moreLighter: "",
    lightest: "",
    lightest2: "",
  },
  cardText: {
    main: "#F5F5DC",
    dark: "#d9d9d9",
    darker: "#b3b3b3",
    moreDarker: "#4d4d4d",
    darkest: "",
    light: "#faf0e6",
    lighter: "",
    moreLighter: "",
    lightest: "",
    lightest2: "",
  },
};

// Text tokens for the light (beige) theme; everything else is shared between modes.
const lightWizardText = {
  ...wizardWorkzPalette.wizardText,
  main: "#3b2a1a",
  dark: "#4a3726",
  light: "#6b5440",
};

export const getPalette = (mode: "light" | "dark") =>
  mode === "light" ? { ...wizardWorkzPalette, wizardText: lightWizardText } : wizardWorkzPalette;
